<template>
  <transition name="modal">
    <div class="confirm-modal-mask" @keyup.esc="$emit('cancel')">
      <div class="modal confirm-modal">
        <div class="modal__header">
          <slot name="header"></slot>
        </div>
        <div class="modal__content">
          <div class="modal__body">
            <slot name="form"></slot>
          </div>
          <div class="modal__footer">
            <div>
              <button
                accept
                class="btn btn--red modal__btn"
                @click="$emit('accept')"
              >
                {{ $t("global.button.accept") }}
              </button>
            </div>
            <div>
              <button
                accept
                class="btn btn--white modal__btn"
                @click="$emit('cancel')"
              >
                {{ $t("global.button.cancel") }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<style src="./css/confirmModalDialogFrame.css"></style>

<script>
export default {
  name: "ConfirmMessageDialog"
};
</script>
